import { render, staticRenderFns } from "./DailyProduce.vue?vue&type=template&id=c48e3e76&scoped=true&"
import script from "./DailyProduce.vue?vue&type=script&lang=js&"
export * from "./DailyProduce.vue?vue&type=script&lang=js&"
import style0 from "./DailyProduce.vue?vue&type=style&index=0&id=c48e3e76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48e3e76",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VDataTable,VIcon})
